import { DialogContent } from '@mui/material';
import React, { FC } from 'react';
import ModalFormTitle from '../Tables/TableWithModalEdit/modalFormPieces/ModalFormTitle';
import { DraggableDialog } from '../DraggablePaper/DraggablePaper';

interface Props {
    open?: boolean;
    toggleOpen: (nextValue?: any) => void;
    reactComponent: React.ComponentType<any>;
    componentProps?: Record<string, any>;
    setOpen?: Function;
    title: string;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    /** Optional pass-through to the dialog Paper (e.g. sx to force a fixed width). */
    paperProps?: Record<string, any>;
}

const GeneralModal: FC<Props> = (props: Props) => {
    const { open = true, toggleOpen, reactComponent: Component, componentProps, title, maxWidth = 'sm', paperProps } = props;
    return (
        <DraggableDialog open={open} onClose={()=>toggleOpen(false)} fullWidth maxWidth={maxWidth} PaperProps={paperProps}>
            <ModalFormTitle title={title} toggleDialog={toggleOpen} />
            <DialogContent>{<Component {...componentProps} />}</DialogContent>
        </DraggableDialog>
    );
};

export default GeneralModal;
